import React from "react";
import {
  Input,
  message,
  Button,
  Space,
  Row,
  Col,
  Modal,
  Tooltip,
  Image,
  Drawer,
  Select,
  Table,
  DatePicker,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined, ExportOutlined } from "@ant-design/icons";
import JourneyPlannerAdd from "./journeyplannerAdd";
import JourneyPlannerStore from "../store/journeyplannerstore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import dayjs from "dayjs";

import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";

class JourneyPlanner extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.journeyPlannerStore = new JourneyPlannerStore();
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyId: "",
      company_value_label: "",
      searchField: "",
      travelTypeFilter: "",
      journeyId: "",
      journeyNum: "",
      openJourneyForm: false,
      listDataUpdate: false,
      openDeleteModal: false,
      deleteData: {},
      openVehicleLogModal: false,
      vehicleLogs: [],
      vehicleLogLoading: false,
      selectedVehicleLogRecord: null,
      openExtendTimeModal: false,
      extendTimeRecord: null,
      extendedDateTime: null,
      extendTimeSaving: false,
      openAlertModal: false,
      alertModalMessage: "",
      closeJourneyModal: false,
      selectedRecord: null,
      isadmin: "",
      userId: ""
    };

    this.columns = [
      {
        title: context.translate("_COMPANY_"),
        dataIndex: "companyName",
        width: 130,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_JOURNEY_NUMBER_"),
        dataIndex: "journeyNum",
        width: 130,
        ellipsis: { showTitle: true },
        render: (value, record) => (
          <Tooltip placement="topLeft" title={value}>
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("journeyplanner") && this.onEdit(record);
              }}
            >
              {value}
            </Link>
          </Tooltip>
        ),
      },
      {
        title: context.translate("_APPLICANT_NAME_"),
        dataIndex: "applicantName",
        width: 130,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_APPLICANT_EMAIL_ID_"),
        dataIndex: "applicantEmailId",
        width: 150,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_APPLICANT_CONTACT_NUMBER_"),
        dataIndex: "applicantContactNo",
        width: 150,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 110,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_JOURNEY_DESK_"),
        dataIndex: "journeyDeskName",
        width: 120,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_TRAVEL_TYPE_"),
        dataIndex: "travelType",
        width: 110,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_PURPOSE_"),
        dataIndex: "purpose",
        width: 110,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_CO_PASSENGERS_"),
        dataIndex: "coPassengers",
        width: 120,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_CHECK_IN_CONTACT_"),
        dataIndex: "applicantContactNo",
        width: 130,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_RISK_SCORE_"),
        dataIndex: "riskScore",
        width: 100,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_PROPOSED_START_TIME_"),
        dataIndex: "proposedStartTime",
        width: 150,
        ellipsis: { showTitle: true },
        render: (val) => {
          const formattedDate = val
            ? dayjs(val).format("DD-MM-YYYY HH:mm:ss")
            : "-";

          return (
            <Tooltip placement="topLeft" title={formattedDate}>
              {formattedDate}
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_PROPOSED_END_TIME_"),
        dataIndex: "proposedEndTime",
        width: 150,
        ellipsis: { showTitle: true },
        render: (val) => {
          const formattedDate = val
            ? dayjs(val).format("DD-MM-YYYY HH:mm:ss")
            : "-";

          return (
            <Tooltip placement="topLeft" title={formattedDate}>
              {formattedDate}
            </Tooltip>
          );
        },
      },
      {
      title: context.translate("_ACTUAL_START_TIME_"),
      dataIndex: "actualStartTime",
      width: 140,
      ellipsis: { showTitle: true },
      render: (val) => {
        const formatted = val
          ? dayjs(val).format("YYYY-MM-DD HH:mm:ss")
          : "-";

        return (
          <Tooltip placement="topLeft" title={formatted}>
            {formatted}
          </Tooltip>
        );
      },
      },
      {
        title: context.translate("_ACTUAL_END_TIME_"),
        dataIndex: "actualEndTime",
        width: 140,
        ellipsis: { showTitle: true },
        render: (val) => {
          const formatted = val
            ? dayjs(val).format("YYYY-MM-DD HH:mm:ss")
            : "-";

          return (
            <Tooltip placement="topLeft" title={formatted}>
              {formatted}
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_TRIP_STATUS_"),
        dataIndex: "journeyStatus",
        width: 110,
        ellipsis: { showTitle: true },
        render: (val, record) => {
          const isAdmin = this.props.getUserData().isadmin // replace with your actual user store value

          let displayText = val;

          if (isAdmin==6) {
            if (
              record.status === 1 &&
              record.isApprovedFromSafety == "1"
            ) {
              displayText = `Approved by ${record.safetyInchargeName}`;
            } else if (
              record.status === 1 &&
              record.isApprovedFromSafety == "0"
            ) {
              displayText = `Rejected by ${record.safetyInchargeName}`;
            }
          } else {
            if (
              record.status === 1 &&
              record.isApprovedFromSafety == "0"
            ) {
              displayText = "Rejected";
            }
          }

          return (
            <Tooltip placement="topLeft" title={displayText}>
              <span
                style={{
                  color:
                    displayText === val ? record.tripColor : undefined,
                }}
              >
                {displayText}
              </span>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        width: 90,
        align: "left",
        ellipsis: { showTitle: true },
        render: (_, record) => (
          <Space>
            {
              !(
                record.status === 5 ||
                (
                  this.props.getUserData().isadmin !== 6 &&
                  this.props.getUserData().isadmin !== 7 &&
                  record.isApprovedFromSafety === 0
                ) ||
                (
                  this.props.getUserData().isadmin !== 6 &&
                  this.props.getUserData().isadmin !== 7 &&
                  record.status === 4
                )
              ) && (
            <Tooltip
              title={this.context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
              placement="bottom"
            >
              <Image
                src={require("../assets/images/NewDesign/editIcon.svg").default}
                style={{ cursor: "pointer", width: "15px" }}
                onClick={() => this.onEdit(record)}
              />
            </Tooltip>
            ) 
           } 
            {!(this.props.getUserData().isadmin !== 6 && this.props.getUserData().isadmin !== 7) && (
              <Tooltip
                title={this.context.translate(
                  "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                )}
                placement="bottom"
              >
                <Image
                  src={require("../assets/images/NewDesign/Delete.png")}
                  style={{ cursor: "pointer", width: "15px" }}
                  onClick={() =>
                    this.setState({
                      openDeleteModal: true,
                      deleteData: record,
                    })
                  }
                />
              </Tooltip>
            )}
            {
              this.props.getUserData().isadmin === 6 &&
              record.status !== 1 &&
              record.status !== 4 &&
              record.status !== 7 && (
                <Tooltip
                  title={this.context.translate("_VEHICLE_LOGS_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/vehiclelogs_icons.png")}
                    style={{ cursor: "pointer", width: "15px" }}
                    onClick={() => this.onVehicleLogs(record)}
                  />
                </Tooltip>
              )
            }
            {
              this.props.getUserData().isadmin === 6 &&
              this.isRunningJourney(record.status) &&
              record.extendedCount < 4 &&
              record.isTimeRequest === 1 && (
                <Tooltip
                  title={this.context.translate("_EXTEND_TIME_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/back-in-time.png")}
                    style={{ cursor: "pointer", width: "15px" }}
                    onClick={() => this.onExtendTime(record)}
                  />
                </Tooltip>
              )
            }
            {
              this.props.getUserData().isadmin === 6 &&
              new Date() > new Date(record.proposedEndTime) &&
              record.status !== 5 && (
                <Tooltip
                  title={this.context.translate("_COMPLETE_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/check.png")}
                    style={{ cursor: "pointer", width: "15px" }}
                    onClick={() => this.onComplete(record)}
                  />
                </Tooltip>
              )
            }
            {

              (
                record.status === 5 ||
                (
                  this.props.getUserData().isadmin !== 6 &&
                  this.props.getUserData().isadmin !== 7 &&
                  record.isApprovedFromSafety === 0
                ) ||
                (
                  this.props.getUserData().isadmin !== 6 &&
                  this.props.getUserData().isadmin !== 7 &&
                  record.status === 4
                )
              ) && (
                <Tooltip
                  title={this.context.translate("_VIEW_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/view.png")}
                    style={{ cursor: "pointer", width: "15px" }}
                    onClick={() => this.onEdit(record)}
                  />
                </Tooltip>
              )
            }
          </Space>
        ),
      },
    ];
  }

  async componentDidMount() {
    this.setState({
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
    });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });

  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.state.openJourneyForm &&
      prevState.openJourneyForm !== this.state.openJourneyForm
    ) {
      setTimeout(() => window.dispatchEvent(new Event("resize")), 10);
    }

    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      await this.handleSearch();
      await this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    const journeyId = record.id;
    const journeyNum = record.journeyNum
    console.log("A", record.journeyId);
    console.log("B", record.id);
    console.log("C", record.journeyNum);
    await this.setState({ openJourneyForm: true, journeyId: journeyId, journeyNum: journeyNum });
  };

  async onDelete(record) {
    const journeyId = record.journeyId || record.id || record.journeyid || record.journeyNum;
    const response = await this.journeyPlannerStore.deleteRecord({
      journeyId: journeyId,
    });
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleTableChange(pagination) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async onVehicleLogs(record) {
    console.log("record>>>>>>>>>>>", record);
    const journeyId = record.journeyId || record.id || record.journeyid || record.journeyNum;
    this.setState({ openVehicleLogModal: true, vehicleLogLoading: true, selectedVehicleLogRecord: record });
    try {
      const response = await this.journeyPlannerStore.getVehicleLog(journeyId);
      const logs = response?.data?.data || response?.data || [];
      this.setState({ vehicleLogs: Array.isArray(logs) ? logs : [] });
      this.setState({ })
    } catch (error) {
      console.error("Error fetching vehicle logs:", error);
      message.error("Failed to fetch vehicle logs");
    } finally {
      this.setState({ vehicleLogLoading: false });
    }
  }

  onExtendTime = (record) => {
    const initialEndTime = record.proposedEndTime || record.expectedArrivalDate;
    this.setState({
      openExtendTimeModal: true,
      extendTimeRecord: record,
      extendedDateTime: initialEndTime ? dayjs(initialEndTime) : null
    });
  };

  onComplete = (record) => {
    this.setState({
      closeJourneyModal: true,
      selectedRecord: record,
    });
  };
  handleCloseJourney = async () => {
    console.log("HIII inside")
    const { selectedRecord, isadmin, userId } = this.state;
    const postdata = {
      Id: selectedRecord.id,
      userId: userId,
      isadmin: isadmin
    }
    try {
      const response = await this.journeyPlannerStore.closeJourney(postdata); // calling mobx action via props
      if (response) {
        this.setState({ closeJourneyModal: false, selectedRecord: null });
        // Optionally refresh data or show success message
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };



  handleSaveExtendTime = async () => {
    const { extendTimeRecord, extendedDateTime } = this.state;
    if (!extendedDateTime) {
      message.error("Please select a date and time");
      return;
    }
    const journeyId = extendTimeRecord?.journeyId || extendTimeRecord?.id || extendTimeRecord?.journeyid || extendTimeRecord?.journeyNum;

    this.setState({ extendTimeSaving: true });
    try {
      const payload = {
        id: journeyId,
        extendedCount: (extendTimeRecord?.extendedCount || 0) + 1,
        extendedDateTime: extendedDateTime.format("YYYY-MM-DD HH:mm:ss")
      };
      const response = await this.journeyPlannerStore.updateExtendedDateTime(payload);
      if (response?.data?.success === "S" || response?.data?.success === true) {
        this.setState({
          openExtendTimeModal: false,
          openAlertModal: true,
          alertModalMessage: "Time Extended Successfully"
        });
        this.handleSearch();
      } else {
        message.error(response?.data?.message || "Failed to extend time");
      }
    } catch (error) {
      console.error("Error extending journey time:", error);
      message.error("An error occurred while extending time");
    } finally {
      this.setState({ extendTimeSaving: false });
    }
  };

  async handleChange({ comp }) {
    if (comp) {
      await this.setState({
        currentPage: 1,
        companyId: comp.value,
        pageSize: 50,
      });
      const singleData = await this.companyStore.getCompanyDataById(comp.value);
      await this.setState({ company_value_label: singleData });
      await this.handleSearch();
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.journeyPlannerStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      searchField: this.state.searchField,
      travelType: this.state.travelTypeFilter,
      isadmin: this.props.getUserData().isadmin,
      applicantNo: "",
      userId: this.state.userId,
    });
    await this.setState({ loading: false });
  }

  responseMsg = async (resp) => {
    if (resp?.data?.success === "S") {
      message.success(resp.data.message);
      await this.setState({ listDataUpdate: true, openJourneyForm: false });
    } else {
      message.error(resp?.data?.message);
    }
  };

  closeModal = () => {
    this.setState({ openJourneyForm: false, journeyId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.journeyPlannerStore.loadData({
      companyId: this.state.companyId,
      offset: 0,
      limit: this.state.pageSize || 50,
      travelType: this.state.travelTypeFilter,
      isadmin: this.props.getUserData().isadmin,
      applicantNo: "",
    });
    this.setState({ loading: false, currentPage: 1 });
  };
  isRunningJourney = (status) => {
  const statusArray = [6, 8, 9];
  return statusArray.includes(parseInt(status));
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(comp) => this.handleChange({ comp })}
                  value={this.state.company_value_label || null}
                  allowClear={true}
                  onClear={() =>
                    this.setState({ company_value_label: null, companyId: "" })
                  }
                  style={{ width: 165 }}
                  fromAccountList={1}
                />
                <Select
                  className="searchInput"
                  style={{ width: 160 }}
                  placeholder="Filter by Travel Type"
                  value={this.state.travelTypeFilter || null}
                  allowClear
                  onClear={async () => {
                    await this.setState({
                      travelTypeFilter: "",
                      currentPage: 1,
                    });
                    await this.handleSearch();
                  }}
                  onSelect={async (val) => {
                    await this.setState({
                      travelTypeFilter: val,
                      currentPage: 1,
                    });
                    await this.handleSearch();
                  }}
                  options={[
                    { value: "", label: "All" },
                    { value: "2", label: "Outside Project" },
                    { value: "1", label: "Within Project" },
                  ]}
                />
                <Input
                  placeholder="Search..."
                  value={this.state.searchField}
                  style={{ width: 250, borderRadius: "25px" }}
                  onChange={async (e) => {
                    await this.setState({ searchField: e.target.value });
                    if (
                      e.target.value.length > 3 ||
                      e.target.value.length === 0
                    ) {
                      await this.handleSearch();
                    }
                  }}
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => {
                      this.refreshList();
                      this.setState({ searchField: "" });
                    }}
                  />
                </Tooltip>
                {(this.props.getUserData().isadmin != 6 && this.props.getUserData().isadmin != 7) && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({ openJourneyForm: true, journeyId: "" })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    />
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>)}

                {/* <Tooltip
                  title={this.context.translate("_DOWNLOAD_")}
                  placement="bottom"
                >
                  <span>
                    <Button
                      className="downloadExcelButton"
                      disabled={
                        this.journeyPlannerStore?.journeys?.length === 0
                      }
                      onClick={() => {
                        const colList = this.columns.map((c) => c.dataIndex);
                        this.journeyPlannerStore.exportExcel({
                          companyId: this.state.companyId,
                          searchField: "",
                          colList,
                        });
                      }}
                    >
                      <Image
                        style={{ height: 18, width: "auto" }}
                        src={downloadIcon}
                      />
                    </Button>
                  </span>
                </Tooltip> */}
              </Space>
            </Col>
          </Row>

          {this.state.openJourneyForm && (
            <Drawer
              className="accountFormDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openJourneyForm}
              footer={false}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              maskClosable={false}
              onCancel={() =>
                this.setState({ openJourneyForm: false, journeyId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <JourneyPlannerAdd
                  journeyId={this.state.journeyId}
                  journeyNum={this.state.journeyNum}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}

          {this.state.openDeleteModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="deleteModalTitle">
                  <span>
                    {this.context.translate(
                      "_FLEET_COMPANY_COMPANYLIST_DELETE_",
                    )}
                  </span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ openDeleteModal: false })}
                  />
                </div>
              }
              className="deleteModal"
              centered
              open={this.state.openDeleteModal}
              footer={null}
              width={400}
              closable={false}
            >
              <div className="deleteModalText">
                <p>{this.context.translate("_DELETE_STATUS_")}</p>
              </div>
              <div className="deleteModalButtons">
                <Button
                  className="deleteModalCancelButton"
                  onClick={() => this.setState({ openDeleteModal: false })}
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>
                <Button
                  className="deleteModalOkButton"
                  onClick={() => this.onDelete(this.state.deleteData)}
                >
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </Button>
              </div>
            </Modal>
          )}

          {this.state.openVehicleLogModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="confirmStatusTitle">
                  <span>Vehicle Log</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ openVehicleLogModal: false, vehicleLogs: [], selectedVehicleLogRecord: null })}
                  />
                </div>
              }
              className="update-statusModal"
              centered
              open={this.state.openVehicleLogModal}
              footer={null}
              width={700}
              closable={false}
            >
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "15px" }}>
                <Button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "32px",
                    height: "32px",
                    padding: 0
                  }}
                  onClick={async () => {
                    try {
                      const journeyId = this.state.selectedVehicleLogRecord?.id;
                      this.journeyPlannerStore.exportVehicleLogExcel({
                        journeyId: journeyId,
                        searchField: "",
                        colList: ["vehicleNo", "reason", "dateTime"],
                      });
                    } catch (error) {
                      console.error("Export error", error);
                    }
                  }}
                >
                  <ExportOutlined style={{ fontSize: "16px", color: "#595959" }} />
                </Button>
              </div>

              <Table
                bordered
                loading={this.state.vehicleLogLoading}
                dataSource={this.state.vehicleLogs}
                columns={[
                  {
                    title: "Asset Name",
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                    render: (text, record) => record.vehicleNo || record.assetName || record.vehicleName || record.vehicle || "-",
                  },
                  {
                    title: "Reason",
                    dataIndex: "reason",
                    key: "reason",
                    render: (text, record) => record.reason || record.remarks || record.description || record.rejectionReason || "-",
                  },
                  {
                    title: "Date & Time",
                    dataIndex: "dateTime",
                    key: "dateTime",
                    render: (val, record) => {
                      const rawDate = record.dateTime || record.datetime || record.createdDate || record.date_time || record.updatedAt || record.date;
                      return rawDate ? dayjs(rawDate).format("YYYY-MM-DD HH:mm:ss") : "-";
                    }
                  }
                ]}
                pagination={false}
                size="small"
              />
            </Modal>
          )}

          {this.state.openExtendTimeModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="confirmStatusTitle">
                  <span>Extended Date Time</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ openExtendTimeModal: false, extendTimeRecord: null, extendedDateTime: null })}
                  />
                </div>
              }
              className="update-statusModal"
              centered
              open={this.state.openExtendTimeModal}
              footer={null}
              width={500}
              closable={false}
            >
              <div style={{ padding: "10px 0" }}>
                <Row align="middle" gutter={16}>
                  <Col span={8}>
                    <span style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
                      Extended Date Time<span style={{ color: "red" }}>*</span>:
                    </span>
                  </Col>
                  <Col span={16}>
                    <DatePicker
                      showTime
                      style={{ width: "100%", height: "40px" }}
                      format="DD-MM-YYYY hh:mm A"
                      value={this.state.extendedDateTime}
                      onChange={(val) => this.setState({ extendedDateTime: val })}
                    />
                  </Col>
                </Row>
              </div>

              <div className="confirmStatusButtons">
                <Button
                  className="confirmStatusCancelButton"
                  onClick={() => this.setState({ openExtendTimeModal: false, extendTimeRecord: null, extendedDateTime: null })}
                >
                  Cancel
                </Button>
                <Button
                  className="confirmStatusOkButton"
                  loading={this.state.extendTimeSaving}
                  onClick={this.handleSaveExtendTime}
                >
                  Save
                </Button>
              </div>
            </Modal>
          )}

          {this.state.openAlertModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="confirmStatusTitle">
                  <span>Alert</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ openAlertModal: false, alertModalMessage: "" })}
                  />
                </div>
              }
              className="update-statusModal"
              centered
              open={this.state.openAlertModal}
              footer={null}
              width={350}
              closable={false}
            >
              <div className="confirmStatusText">
                <p>{this.state.alertModalMessage}</p>
              </div>

              <div className="confirmStatusButtons">
                <Button
                  className="confirmStatusOkButton"
                  onClick={() => this.setState({ openAlertModal: false, alertModalMessage: "" })}
                >
                  OK
                </Button>
              </div>
            </Modal>
          )}
          {this.state.closeJourneyModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="confirmStatusTitle">
                  <span>Close Journey</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ closeJourneyModal: false, selectedRecord: null })}
                  />
                </div>
              }
              className="update-statusModal"
              centered
              open={this.state.closeJourneyModal}
              footer={null}
              width={350}
              closable={false}
            >
              <div className="confirmStatusText">
                <p>{this.context.translate("_ARE_YOU_SURE_CLOSE_JOURNEY_")}</p>
              </div>

              <div className="confirmStatusButtons">
                <Button
                  className="confirmStatusOkButton"
                  onClick={this.handleCloseJourney}
                >
                  {this.context.translate("_YES_")}
                </Button>
                <Button
                  className="confirmStatusOkButton"
                  onClick={() => this.setState({ closeJourneyModal: false, selectedRecord: null })}
                >
                  {this.context.translate("_NO_")}
                </Button>
              </div>
            </Modal>
          )}

          {/* <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.journeyPlannerStore?.total}
            columns={this.columns}
            dataSource={this.journeyPlannerStore?.journeys}
            loading={this.journeyPlannerStore?.loading}
            onChange={this.handleTableChange}
          /> */}
          <ListTable
          currentPage={this.state.currentPage}
          pageSize={this.state.pageSize}
          total={this.journeyPlannerStore?.total}
          columns={this.columns}
          dataSource={this.journeyPlannerStore?.journeys}
          loading={this.journeyPlannerStore?.loading}
          onChange={this.handleTableChange}
          rowClassName={(record) => {
          if (record.isTimeRequest === 1) {
            return "background-orange";
          }

          let extendedDate = null;

          if (record.extendedCount === 1) {
            extendedDate = record.extendedDateTime;
          } else if (record.extendedCount === 2) {
            extendedDate = record.extendedDateTime2;
          } else if (record.extendedCount === 3) {
            extendedDate = record.extendedDateTime3;
          }

          if (
            record.status !== 5 &&
            extendedDate &&
            dayjs().isAfter(dayjs(extendedDate))
          ) {
            return "background-red";
          }

          return "";
        }}
        />
        </div>
      </>
    );
  }
}

JourneyPlanner.contextType = StoreContext;
export default observer(withRouter(JourneyPlanner));
